import React, { useEffect } from "react";

import Step1Image from "../../assets/img/step-two.webp";
import Step2Image from "../../assets/img/doctoe2.webp";
import Step3Image from "../../assets/img/doctor.webp";
import Step4Image from "../../assets/img/step-four.webp";
import { useNav } from "../../context/nav-context";
import { useInView } from "react-intersection-observer";
import "animate.css";

const SmilesStep = () => {
  const steps = [
    {
      title: "Step 1 <br/> Start your journey",
      description:
        "It all starts with a consultation with your dental professional. During this visit, we will assess your smile, discuss your goals, and determine if clear aligners are the right solution for you. This phase often includes a comprehensive examination, including X-rays, photographs, and impressions of your teeth. This step is all about understanding your unique situation and setting the foundation for a successful treatment.",
      image: Step2Image,
    },
    {
      title: "Step 2 <br/> Custom Plan",
      description:
        "Once the initial assessment is complete, we will create a tailored treatment plan. Using advanced digital scanning technology and software, a 3D model of your teeth is generated to map out their gradual movement. This plan provides a clear visualisation of the transformation process, showing how your smile will improve over the course of your treatment.",
      image: Step1Image,
    },
    {
      title: "Step 3 <br/> Treatment Begins",
      description:
        "With your aligners ready, treatment begins! You’ll receive a set of aligners that need to be worn for approximately 20-22 hours per day, changing to a new set every two weeks as. Regular check-ins with us ensure that the treatment is progressing as planned. During this phase, you may notice gradual changes as your teeth start shifting into their new positions.",
      image: Step3Image,
    },
    {
      title: "Step 4 <br/> Smile Transformation",
      description:
        "After you’ve worn all your aligners, your treatment concludes with a stunning smile transformation. This final phase includes ensuring that your teeth are properly aligned and that you’re satisfied with the results. To maintain your new smile, you’ll be provided with a retainer to wear each night. The retainers help prevent your teeth from shifting back to their original positions, ensuring your hard-earned results last a lifetime.",
      image: Step4Image,
    },
  ];

  const [ref, inView] = useInView({
    triggerOnce: false, // Trigger animations each time the element comes into view
    threshold: 0.2, // Trigger when 20% of the component is visible
  });
  const { setActiveLink } = useNav();
  // Update activeLink to "journey" when this section is in view
  useEffect(() => {
    if (inView) {
      setActiveLink("journey");
    }
  }, [inView, setActiveLink]);
  return (
    <div ref={ref} className="container-fluid mt-5 rounded-5" id="journey">
      <div className="card text-white border-0 rounded-4 bg-brown p-5">
        <div
          className={`row align-items-center mb-3 ${
            inView ? "animate__animated animate__zoomIn" : ""
          }`}
        >
          <div className="col-md-8">
            <h2 className="fs-46 fw-400 text-center text-md-start ">
              Your Simple Steps To A New Smile
            </h2>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button className="btn btn-light rounded-5 px-4 py-3 fs-24">
              Get in touch
            </button>
          </div>
        </div>
        <div
          className={`row mt-4 ${
            inView ? "animate__animated animate__zoomIn" : ""
          }`}
        >
          {steps.map((step, index) => {
            const [beforeBr, afterBr] = step.title.split("<br/>");

            return (
              <div key={index} className="col-md-3 mb-4">
                <div className="position-relative step-card">
                  <div className="d-flex justify-content-center">
                    <img
                      src={step.image}
                      alt={`Step ${index + 1}`}
                      className="img-fluid rounded-3 w-100 position-relative"
                    />
                    <h4 className="text-light fs-22 mb-3 text-center bottom-0 position-absolute step-title-text">
                      <span className="text-yellow">{beforeBr}</span>
                      <br />
                      <span className="text-white">{afterBr}</span>
                    </h4>
                  </div>

                  <div className="overlay position-absolute top-0 left-0 right-0 bottom-0 d-flex justify-content-center align-items-end text-center bg-dark bg-opacity-50 text-white">
                    <div className="d-flex flex-column align-items-center p-3">
                      <h4 className="text-light fs-18 mb-3">
                        <span className="text-warning">{beforeBr}</span>
                        <br />
                        <span className="text-white">{afterBr}</span>
                      </h4>
                      <p
                        className="fs-14 fw-200"
                        dangerouslySetInnerHTML={{ __html: step.description }}
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SmilesStep;
